import React from 'react';
import styled from 'styled-components';
import { Button, Container } from '../../Component/styledComponents/styledComponents';
import LicenceImage from '../../Component/Images/licence.jpg';
import {
    ButtonWrapper,
    Heading,
    HeadingSection,
    HeadingWrapper,
    HeadText,
    Icon,
    Image,
    Line,
    List,
    Root,
    Text,
    TextTab,
    Wrapper
} from '../../Component/styledComponents/TermsAndConditionStyledComponents';
import { useNavigate } from 'react-router-dom';


function RefundPolicy(props) {
    const navigate = useNavigate();
    return (
        <Root>
            <Container>
                <Wrapper>
                    <HeadingSection>
                        <HeadingWrapper>
                            <Heading>Cancellation & Refund Policy </Heading>
                            <Line style={{
                                background: "linear-gradient(90deg, #68e7f2, #69e2c1)",
                                height: "20px",
                            }}></Line>
                        </HeadingWrapper>

                    </HeadingSection>
                    <TextTab></TextTab>


                    <Text>
                        This <strong>Cancellation and Refund Policy</strong> outlines the terms and conditions governing cancellations and refunds for services purchased from BastionEx.
                    </Text>
                    <Text>
                        By accessing or using our services, you agree to the terms outlined below.
                    </Text>

                    <HeadText>Important Notice: No Refund Policy</HeadText>
                    <Text>
                        BastionEx does not offer refunds for any products or services once a transaction has been completed.
                    </Text>
                    <Text>
                        All payments made through our platform are final and non-refundable. Customers are solely responsible for the use of their own funds through the card services facilitated by BastionEx.
                    </Text>

                    <HeadText>Service Description</HeadText>
                    <Text>
                        BastionEx provides access to card services and related tools that allow customers to manage and use their own funds. BastionEx does not hold customer funds, nor do we act as a bank, financial institution, or money service provider.
                    </Text>
                    <Text>
                        Our role is strictly limited to facilitating access to the card platform and related service features.
                    </Text>

                    <HeadText>Order and Subscription Cancellations</HeadText>
                    <List>
                        <Icon />
                        <Text><strong> Orders:</strong> Once a service order is confirmed and processed, it cannot be cancelled.</Text>
                    </List>
                    <List>
                        <Icon />
                        <Text><strong> Subscriptions:</strong> Customers may cancel any active subscription to halt future renewals, but no refunds will be issued for any prior or current billing cycle.</Text>
                    </List>

                    <HeadText>Non-Refundable Services</HeadText>
                    <Text>
                        All services offered on BastionEx are non-refundable, including but not limited to:
                    </Text>
                    <List>
                        <Icon />
                        <Text> Card issuance fees</Text>
                    </List>
                    <List>
                        <Icon />
                        <Text> Platform access fees</Text>
                    </List>
                    <List>
                        <Icon />
                        <Text> Subscription fees</Text>
                    </List>
                    <List>
                        <Icon />
                        <Text> Account setup or activation charges</Text>
                    </List>
                    <List>
                        <Icon />
                        <Text> Any service-related transaction fees</Text>
                    </List>
                    <Text>
                        These charges are clearly disclosed at the time of purchase.
                    </Text>

                    <HeadText>Customer Responsibility</HeadText>
                    <List>
                        <Icon />
                        <Text>By using BastionEx's services, customers acknowledge and agree that:</Text>
                    </List>
                    <List>
                        <Icon />
                        <Text> All transactions are initiated using their own funds.</Text>
                    </List>
                    <List>
                        <Icon />
                        <Text> BastionEx is not liable for any misused, unauthorized, or unintended transactions.</Text>
                    </List>
                    <List>
                        <Icon />
                        <Text> It is the customer’s responsibility to ensure correct use of the platform.</Text>
                    </List>

                    <HeadText>Exceptions</HeadText>
                    <Text>
                        Refunds or service credits will only be considered under the following exceptional conditions:
                    </Text>
                    <List>
                        <Icon />
                        <Text> The service was not delivered at all due to a verifiable technical issue caused by BastionEx.</Text>
                    </List>
                    <List>
                        <Icon />
                        <Text> The transaction was fraudulently processed without the customer's consent and verified as such by our compliance team.</Text>
                    </List>
                    <Text>
                        All exception claims are subject to internal investigation and approval.
                    </Text>

                    <HeadText>Changes to Policy</HeadText>
                    <Text>
                        BastionEx reserves the right to modify or update this Cancellation and Refund Policy at any time. Updates become effective once posted on the Website. Customers are advised to review this policy periodically.
                    </Text>

                    <HeadText>Contact Information</HeadText>
                    <Text>
                        For any questions or concerns regarding this policy, please contact our customer support team:
                    </Text>
                    <Text>📧 <strong>info@bastionex.net</strong></Text>



                    <ButtonWrapper>
                        <Button
                            bgcolor="#00a97c"
                            color="#fff"
                            top="15px"
                            right="30px"
                            bottom="15px"
                            left="30px"
                            radius="30px"
                            onClick={() => (navigate("/contact_us"))}
                        >
                            Contact Us
                        </Button>
                    </ButtonWrapper>
                </Wrapper>
            </Container>
        </Root>
    );
}

export default RefundPolicy;